import styles from '../track-grid.module.css'

import React from 'react'

import Skeleton from 'components/ui/skeleton'

type SkeletonTrackRowProps = {
  index: number
}

export const SkeletonTrackRow = ({ index }: SkeletonTrackRowProps) => {
  return (
    <div className={styles.skeletonRow}>
      <div className={styles.trackNumberContainer}>
        <span className={styles.trackNumber}>{index + 1}</span>
      </div>
      <div className={styles.skeletonArtwork}>
        <Skeleton lines={1} type="block" />
      </div>
      <div className={styles.skeletonTitle}>
        <Skeleton lines={1} type="block" />
      </div>
      <div className={styles.skeletonBusiness}>
        <Skeleton lines={1} type="block" />
      </div>
      <div className={styles.skeletonWaveform}>
        <Skeleton lines={1} type="block" />
      </div>
      <div className={styles.skeletonDuration}>
        <Skeleton lines={1} type="block" />
      </div>
    </div>
  )
}

export default SkeletonTrackRow
